import * as React from 'react';
import HomeEntMobileImg from '../../assets/images/press/crazy_rich_asians_1920x900-mobile.png';
import HomeEntTabletImg from '../../assets/images/press/crazy_rich_asians_1920x900-tablet.png';
import HomeEntImg from '../../assets/images/press/crazy_rich_asians_1920x900.png';
import TheatricalMobileImg from '../../assets/images/press/Fantastic_Beasts_1920x900-mobile.png';
import TheatricalTabletImg from '../../assets/images/press/Fantastic_Beasts_1920x900-tablet.png';
import TheatricalImg from '../../assets/images/press/Fantastic_Beasts_1920x900.png';
import GamesMobileImg from '../../assets/images/press/mk11_1920x900-mobile.png';
import GamesTabletImg from '../../assets/images/press/mk11_1920x900-tablet.png';
import GamesImg from '../../assets/images/press/mk11_1920x900.png';
import BannerMobileImg from '../../assets/images/press/wonder_woman_1984_4320x1080-mobile.png';
import BannerTabletImg from '../../assets/images/press/wonder_woman_1984_4320x1080-tablet.png';
import BannerImg from '../../assets/images/press/wonder_woman_1984_4320x1080.png';
import TelevisionMobileImg from '../../assets/images/press/WW_1920x900-mobile.jpg';
import TelevisionTabletImg from '../../assets/images/press/WW_1920x900-tablet.jpg';
import TelevisionImg from '../../assets/images/press/WW_1920x900.jpg';
import { PressMaterialData } from '../../components/press-material/PressMaterial.props';
import PressCenterLayout from '../../layout/press-center/PressCenterLayout';
// @todo
const seo = {
  description: '',
};

const bannerAlt = 'Presse';
const topBannerProps = {
  imageWithPresets: {
    image: { alt: bannerAlt, src: BannerImg },
    tabletImage: { alt: bannerAlt, src: BannerTabletImg },
    mobileImage: { alt: bannerAlt, src: BannerMobileImg },
  },
  titleProps: {
    title: 'Pressebereich',
  },
};

const theatricalAlt = 'Kino';
const homeEntAlt = 'Home Entertainment';
const tvAlt = 'Consumer Products';
const gamesAlt = 'Games';
const pressMaterialData: PressMaterialData[] = [
  {
    title: 'Kino',
    subTitle: [
      {
        link: 'http://mediapass.warnerbros.com/',
        text: 'Pressematerial',
        target: '_blank',
      },
      {
        link: 'mailto:wbpresse@wbd.com',
        text: 'Pressekontakt',
        target: '_blank',
      },
    ],
    imageWithPresets: {
      image: { alt: theatricalAlt, src: TheatricalImg },
      tabletImage: { alt: theatricalAlt, src: TheatricalTabletImg },
      mobileImage: { alt: theatricalAlt, src: TheatricalMobileImg },
    },
  },
  {
    title: 'Home Entertainment',
    subTitle: [
      {
        link: 'http://presse.warnerbros.de/',
        text: 'Pressematerial',
        target: '_blank',
      },
      {
        link: 'mailto:whvpresse@wbd.com',
        text: 'Pressekontakt',
        target: '_blank',
      },
    ],
    imageWithPresets: {
      image: { alt: homeEntAlt, src: HomeEntImg },
      tabletImage: { alt: homeEntAlt, src: HomeEntTabletImg },
      mobileImage: { alt: homeEntAlt, src: HomeEntMobileImg },
    },
  },
  {
    title: 'Consumer Products',
    subTitle: [
      {
        link: 'https://swordfish-pr.uncovr.com/Login.aspx?reg=2',
        text: 'Pressematerial',
        target: '_blank',
      },
      {
        link: 'pressekontakt',
        text: 'Pressekontakt',
        target: '_blank',
      },
    ],
    imageWithPresets: {
      image: { alt: tvAlt, src: TelevisionImg },
      tabletImage: { alt: tvAlt, src: TelevisionTabletImg },
      mobileImage: { alt: tvAlt, src: TelevisionMobileImg },
    },
    bottomPadding: 5,
  },
  {
    title: 'Games',
    subTitle: [
      {
        link: 'http://wbie-press.com/',
        text: 'Pressematerial',
        target: '_blank',
      },
      {
        link: 'mailto:wbiepresse@wbd.com',
        text: 'Pressekontakt',
        target: '_blank',
      },
    ],
    imageWithPresets: {
      image: { alt: gamesAlt, src: GamesImg },
      tabletImage: { alt: gamesAlt, src: GamesTabletImg },
      mobileImage: { alt: gamesAlt, src: GamesMobileImg },
    },
    bottomPadding: 5,
  },
];

// noinspection JSUnusedGlobalSymbols
export default () => (
  <PressCenterLayout
    locale='de-DE'
    seo={seo}
    pageTitle='Presse'
    displayTitle='Pressematerial & Kontakte'
    pressMaterialData={pressMaterialData}
    topBannerProps={topBannerProps}
  />
);
